import VirtualScroll from 'virtual-scroll'

export default class SmoothScroll {

	constructor(options, vsOptions = {}){
		this.el = vsOptions.el
		this.ease = options.ease || .1
		this.targetY = 0
		this.oldtY = 0
		this.currentY = 0
        this.scrollBar = document.querySelector('#scrollbar')        
        this.scrollBarContainer = this.scrollBar.parentNode
        this.scrollBarY = 0
        this.clickStartPos = 0
        this.clickActualPos = 0
        this.clickDiff = 0
        this.scrollBarOldPos = 0
        this.ratio = 0
        this.isFirefox = navigator.userAgent.indexOf('Firefox') > -1

		this.destroyed = false
        this.drag = false
		this.vs = new VirtualScroll(vsOptions)
        const self = this
	}

	init(){
        this.defineAnimatedElementsPosition()
		this.height = this.getHeight()
		this.vs.on( this.onScroll.bind(this) )
        this.initScrollBar()
		this.animate()
        this.dragHandler()
	}

	onScroll(e){
        if (this.isFirefox) {
            this.targetY += e.deltaY * 2.5
        } else {
            this.targetY += e.deltaY
        }
		this.targetY = Math.max( (this.height - window.innerHeight) * -1, this.targetY)
		this.targetY = Math.min(0, this.targetY)
	}
    
    dragHandler(){
        var self = this
        this.scrollBarClick = this.scrollBarClick.bind(this)
        this.scrollBar.addEventListener('mousedown', this.scrollBarClick)        
    }
    
    scrollBarClick(event) {
        this.drag = true
        this.clickStartPos = event.clientY
        this.scrollBarOldPos = this.currentY
        event.preventDefault()
        
        this.scrollBarContainer.classList.add('is-active')
        
        this.scrollBarMove = this.scrollBarMove.bind(this)
        document.addEventListener('mousemove', this.scrollBarMove)
        
        this.scrollBarUnClick = this.scrollBarUnClick.bind(this)
        document.addEventListener('mouseup', this.scrollBarUnClick)
    }
    
    scrollBarUnClick(event){
        if (this.drag === true) {                
            this.drag = false
            this.scrollBarContainer.classList.remove('is-active')
            document.removeEventListener('mousemove', this.scrollBarMove)
            document.removeEventListener('mouseup', this.scrollBarUnClick)
        }
    }
    
    scrollBarMove(event) {
        if(this.drag === true) {        
            document.body.focus()
            this.clickActualPos = event.clientY
            this.clickDiff = (this.clickStartPos - this.clickActualPos) / this.ratio

            if (this.scrollBarOldPos + this.clickDiff < 0 && this.scrollBarOldPos + this.clickDiff > -(this.height - window.innerHeight)) {
                this.targetY = (this.scrollBarOldPos + this.clickDiff)
            } else if (this.scrollBarOldPos + this.clickDiff > 0) {
                this.targetY = 0
            } else if (this.scrollBarOldPos + this.clickDiff < -(this.height - window.innerHeight)) {
                this.targetY = -(this.height - window.innerHeight)
            }
            return false
        }
    }

	getHeight(){
		return this.el.getBoundingClientRect().height
	}
    
    initScrollBar(){
        this.ratio = window.innerHeight / this.height
        this.scrollBar.style.height = this.getRoundedValue(this.ratio*100) + '%'       
    }

	onResize(){
		this.height = this.getHeight()
        this.initScrollBar()
        this.defineAnimatedElementsPosition()
	}

	animate(){
		if (this.destroyed) {
			return undefined
		}
		else if (this.callbackWhenReachOffset && (this.currentY >= this.targetY - 1 && this.currentY <= this.targetY + 1) ) {
			return this.reachOffset()
		}
		else {
			requestAnimationFrame(this.animate.bind(this));
		}
		this.oldY = this.currentY
		this.currentY += this.getRoundedValue( (this.targetY - this.currentY) * this.ease )
        
		this.applyTransform(this.el, this.currentY)
        this.applyTransform(this.scrollBar, (this.currentY * this.ratio) * -1)
        
        this.checkAnimatedElements()
	}
    
    defineAnimatedElementsPosition() {
        this.animatedElements = Array.prototype.slice.call(document.getElementsByClassName('is-scrollAnimated'))
        var i = 0;
        this.animatedElements.forEach(function(element) {
            var positions = element.getBoundingClientRect()
            if (element.classList.contains('nomargin')) {
                element.top = -(positions.top - window.innerHeight);
            } else {                
                element.top = -(positions.top - window.innerHeight + 150);
            }
            i++;
        });
    }
    checkAnimatedElements() {
        var self = this
        var i = 0
        this.animatedElements.forEach(function(element) {
            if (element.top >= self.currentY && !element.classList.contains('is-visible')) {
                element.classList.add('is-visible')
                
                if (element.nodeName === "VIDEO") {
                    element.play();
                } else if (element.classList.contains('is-videoContainer')) {
                    element.querySelector('video').play()
                }
            }
            i++
        });
    }

	applyTransform(el, transformY){
		let t = 'translate3d(0, ' + transformY + 'px, 0)'
		let s = el.style
		s["transform"] = t
		s["webkitTransform"] = t
		s["mozTransform"] = t
		s["msTransform"] = t
	}

	scrollTo(offset, callback){
		this.targetY = offset

		if (callback) {
			if (this.destroyed) { return callback() }
			this.scrollToCallback = callback
			this.callbackWhenReachOffset = true
		}
	}

	getRoundedValue(valueToRound){
		let roundedValue = valueToRound * 1000
		roundedValue = Math.round(roundedValue)
		roundedValue = roundedValue / 1000

		return roundedValue
	}

	reachOffset(){
		this.scrollToCallback()
		this.scrollToCallback = null
		this.callbackWhenReachOffset = false
	}

	reset(){
		this.targetY = 0
		this.currentY = 0
        this.scrollBar.removeEventListener('mousedown', this.scrollBarClick)
	}

	off(){
		this.vs.off()
	}

	destroy(){
		this.destroyed = true
		this.reset()
		this.vs.destroy()
	}

}



// WEBPACK FOOTER //
// ./src/assets/js/smoothScroll.js